import React, { useEffect, useState } from 'react'
import { EditIcon, StarOutline } from '../../components/Icons'
import OverAllRating from '../../components/overAllRating/OverAllRating'
import Comments from '../../components/comments/Comments'
import UserImg from '../../assets/images/user.jpg'
import './viewDetails.scss'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import { setLoader } from '../../slice/commonSlice'
import { useDispatch, useSelector } from 'react-redux';
import { fetchProviderRatingDetail, findUserById } from '../../services/auth.service';
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchImage, getFullName } from '../../utils/common'
import StarRating from '../../components/rating/StarRating'
const ViewProfileDetails = () => {
    const location = useLocation()
    const [providerData, setProviderData] = useState({});
    let id = location.state;
    const dispatch = useDispatch();
    const [rating, setRating] = useState();
    useEffect(() => {
        if(id){
            fetchProfileData();
            fetchRating();
        }
      }, [id]);
      const fetchRating = async () => {
        let payload = {
          "providerId" : id,
          "serviceId" : '',
          "pageNumber": 1
        }
        await dispatch(setLoader(true));
        try {
          const response = await fetchProviderRatingDetail(payload);
          await dispatch(setLoader(false));
          if (response.data.status) {
            setRating(response.data.ratings);
          }
        } catch (error) {
          await dispatch(setLoader(false));
          console.error("Error fetching data:", error);
        }
      }
              // Fetch provider profile data from the API
              const fetchProfileData = async () => {
                await dispatch(setLoader(true));
              try {
                let payload = {
                    "_id": id
                }
                const response = await findUserById(payload);
                setProviderData(response.data); // Use response.data to access the data
               await dispatch(setLoader(false));
              } catch (error) {
                console.error("Error fetching profile data:", error);
               await dispatch(setLoader(false));
              }
            };
    return (
        <>
        <Header />
            <PageHeading title="View Profile"/>
            <div className='main-container'>
            <div className='view-details-wrap box-wrapper'>
                <div className='user-account-detail-top'>
                    <div className='user-img-wrap'>
                        <div className='user-pic'>
                            <img src={providerData?.personData?.profilePic} alt="User" />
                        </div>
                        {/* <div className='edit-pic'><EditIcon /></div> */}
                    </div>
                    <div className='user-name-wrap'>
                        <div className='username'>{getFullName(providerData?.personData?.firstName, providerData?.personData?.lastName)}</div>
                        <div className='user-rating-wrap'>
                            <div className='rating'>
                            <StarRating size={22} rating={providerData?.personData?.ratingProvider} />
                                {/* <StarOutline /> <StarOutline /> <StarOutline /><StarOutline /> <StarOutline /> */}
                                </div>

                        </div>
                    </div>


                </div>
                <div className='user-description'>{providerData?.personData?.bio}</div>
                <div className='expertise-wrap'>
                    <div  className='expertise-title'>Expertise</div>
                    <div className='expertise-row'>
                        {
                            providerData?.expertiseList?.length > 0 ?
                            <>
                            {
                                providerData?.expertiseList?.map((item)=>(
                                    <div className='expertise'>{item}</div>
                                ))
                            }
                            </>
                            : <p>No expertise found</p>
                        }
                    </div>
                </div>
                <div className='view-overall-rating-wrap'> <OverAllRating data={providerData?.personData}/></div>

                <div className='all-review-wrapper'>
                    <div className='all-review-title'>All Reviews</div>
                    <Comments rating={rating} />
                </div>
            </div>
            </div>
            <Footer />
        </>
    )
}

export default ViewProfileDetails
